
import {
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
} from "@/components/ui/alert-dialog";

interface DeleteTestDialogProps {
  onConfirm: () => Promise<void>;
  isDeleting?: boolean;
}

export const DeleteTestDialog = ({ onConfirm, isDeleting = false }: DeleteTestDialogProps) => {
  return (
    <AlertDialogContent className="bg-card">
      <AlertDialogHeader>
        <AlertDialogTitle className="text-foreground">Are you sure?</AlertDialogTitle>
        <AlertDialogDescription className="text-muted-foreground">
          This action cannot be undone. This will permanently delete the test
          and all associated data including responses, evaluations, and results.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel className="bg-background text-foreground hover:bg-accent" disabled={isDeleting}>
          Cancel
        </AlertDialogCancel>
        <AlertDialogAction
          onClick={onConfirm}
          className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          disabled={isDeleting}
        >
          {isDeleting ? "Deleting..." : "Delete"}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  );
};
